// ./controllers/flatpickr_controller.js
// import stimulus-flatpickr wrapper controller to extend it
import Flatpickr from 'stimulus-flatpickr'

// import translations
import { German } from 'flatpickr/dist/l10n/de.js'
import { Austria } from 'flatpickr/dist/l10n/at.js'
import { English } from 'flatpickr/dist/l10n/default.js'

// Erweitertes deutsches chrono für natürlichsprachige Datumseingabe
// („nächsten Freitag", „Monatsende", „KW 27", „in 3 Tagen" …)
import deChrono from '../src/datetime/de_chrono'

// import a theme (could be in your main CSS entry too...)
// import 'flatpickr/dist/themes/dark.css'

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {

    initialize() {
        // Get locale from data attribute or default to German
        const locale = this.element.dataset.locale || 'de'

        // Set locale based on country setting
        let selectedLocale
        switch(locale) {
            case 'at':
                selectedLocale = Austria
                break
            case 'en':
                selectedLocale = English
                break
            default:
                selectedLocale = German
        }

        // static:false bewusst: static:true verursacht in flatpickr 4.6.13 eine
        // Endlosschleife in buildMonthDays, wenn der Datepicker in einem zunächst
        // VERSTECKTEN Slideover/Modal initialisiert wird (z.B. todo[due] im „Neue
        // Aufgabe"-Panel) → Main-Thread blockiert (~4,5 Mio DOM-Nodes) → Windows-Edge
        // Renderer-OOM-Crash (msedge.exe 0xe0000008). Per CDP-Debugger nachgewiesen.
        // (Modal-Datepicker-Positionierung später separat lösen, z.B. lazy-init beim
        // Öffnen des Modals statt static.)

        // sets your language
        this.config = {
            locale: selectedLocale,
            time_24hr: true,
            allowInput: true,
            altInput: true,
            altFormat: 'd.m.Y',
            dateFormat: 'd.m.Y',
            altInputClass: "tw-form-control input",
            static: false
        }

        // Natural-Language-Datumseingabe (chrono.de) — ABSCHALTBARES FEATURE, Default AUS.
        // An/Aus über Setting.feature_flatpickr_natural_language, serverseitig als
        // <meta name="flatpickr-nl-enabled"> gerendert. Nur wenn aktiviert übernimmt chrono.de
        // flatpickrs parseDate (Freitext „nächsten Freitag", „Monatsende", „KW 27" …). Ist es aus,
        // bleibt der Standard-flatpickr-Parser unangetastet. „today" = flatpickr-Keyword (min-date).
        const nlEnabled = (() => {
            const m = document.querySelector('meta[name="flatpickr-nl-enabled"]')
            return !!m && m.content === 'true'
        })()
        if (nlEnabled) {
            this.config.parseDate = (datestr) => {
                const s = (datestr || '').trim()
                if (!s) return undefined
                if (s.toLowerCase() === 'today') return new Date()
                const res = deChrono.parse(s, new Date(), { forwardDate: true })
                return (res.length && res[0].start) ? res[0].start.date() : undefined
            }
        }
    }
}
